module.exports = __webpack_public_path__ + "img/purple-2-squiggly-striped.749ef4b6.svg";